import React, { useState } from "react";

import {
  useTable,
  useRowSelect,
  useSortBy,
  usePagination,
  useFilters,
} from "react-table";

import {
  Flex,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Text,
  Icon,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  useDisclosure,
} from "@chakra-ui/react";

import { FaSortUp, FaSortDown, FaSort } from "react-icons/fa";
import { BsEye, BsThreeDots } from "react-icons/bs";
import { FiEdit } from "react-icons/fi";
import { BiBlock } from "react-icons/bi";

import TablePagination from "../../../../components/TablePagination";

import VisualizarEditarPessoaModal from "../VisualizarEditar";
import DesligarModal from "../VisualizarEditar/Desligar";
import { Permission, servicos } from "../../../../../helpers/Funcionalidades";
import { useAppContext } from "../../../../../Context/MessageContextProvider";

const TableEquipe = (props) => {
  const {
    data,
    columns,
    handleGetPessoaEmCumprimento,
    idSA,
    editarPenaServ,
    setEditarPenaServ,
    roleKeycloack,
    user,
  } = props;

  const { idPJ } = useAppContext();

  const {
    isOpen: isOpenVisualizarEditar,
    onOpen: onOpenVisualizarEditar,
    onClose: onCloseVisualizarEditar,
  } = useDisclosure();

  const {
    isOpen: isOpenDesligar,
    onOpen: onOpenDesligar,
    onClose: onCloseDesligar,
  } = useDisclosure();

  const [pessoaId, setPessoaId] = useState(-1);
  const [dataInicioAtividades, setDataInicioAtividades] = useState("");
  const [isEdicao, setIsEdicao] = useState(false);
  const [nItens] = useState(10);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    canPreviousPage,
    canNextPage,
    gotoPage,
    pageOptions,
    page,
    pageCount,
    nextPage,
    previousPage,
    setPageSize,
    state,
  } = useTable(
    {
      columns,
      data,
      initialState: {
        filters: [],
        pageIndex: 0,
        sortBy: [
          {
            id: "nome",
            desc: false,
          },
        ],
        pageSize: nItens,
      },
    },
    useFilters,
    useSortBy,
    usePagination,
    useRowSelect,
    (hooks) => {
      hooks.visibleColumns.push((columns) => [
        ...columns,
        {
          id: "options",
          Header: "Opções",
          Cell: ({ row }) => (
            <Flex justifyContent="center">
              <Menu>
                <MenuButton
                  as={IconButton}
                  icon={<BsThreeDots color="#fff" fontSize="20px" />}
                  variant={"link"}
                  cursor={"pointer"}
                  backgroundColor="#95BCBF"
                  rounded={100}
                  p={2}
                />
                <MenuList>
                  <MenuItem
                    p={2}
                    color={"#374BCE"}
                    onClick={() => {
                      setPessoaId(row.original.id);
                      setIsEdicao(false);
                      onOpenVisualizarEditar();
                    }}
                  >
                    <BsEye />
                    <Text ml="5px">Visualizar</Text>
                  </MenuItem>
                  <Permission
                    roleKeycloack={roleKeycloack}
                    func={servicos.cumprimentoEditar}
                    id={idPJ}
                    user={user}
                  >
                    <MenuItem
                      p={2}
                      color={"#374BCE"}
                      onClick={() => {
                        setPessoaId(row.original.id);
                        setIsEdicao(true);
                        onOpenVisualizarEditar();
                      }}
                    >
                      <FiEdit />
                      <Text ml="5px">Editar</Text>
                    </MenuItem>
                  </Permission>
                  <Permission
                    roleKeycloack={roleKeycloack}
                    func={servicos.cumprimentoDesligar}
                    id={idPJ}
                    user={user}
                  >
                    <MenuItem
                      p={2}
                      color={"red.500"}
                      onClick={() => {
                        setPessoaId(row.original.id);
                        setDataInicioAtividades(
                          row.original.dataInicioAtividades
                        );
                        onOpenDesligar();
                      }}
                    >
                      <BiBlock />
                      <Text ml="5px">Desligar</Text>
                    </MenuItem>
                  </Permission>
                </MenuList>
              </Menu>
            </Flex>
          ),
        },
      ]);
    }
  );

  const handlePessoaDesligada = () => {
    setPessoaId(-1);
    setDataInicioAtividades("");
    handleGetPessoaEmCumprimento();
    onCloseDesligar();
  };

  function irParaPagina(pagina) {
    gotoPage(pagina);
  }

  function selecionarTotalItens(nItens) {
    setPageSize(nItens);
  }

  const handleCloseVisualizarEditarModal = () => {
    setPessoaId(-1);
    handleGetPessoaEmCumprimento();
    onCloseVisualizarEditar();
  };

  return (
    <Flex flexDir="column" overflowX="auto">
      <Table {...getTableProps} backgroundColor="white" mt="5px">
        <Thead backgroundColor="#ECEFF1">
          {headerGroups.map((headerGroup, index) => (
            <Tr {...headerGroup.getHeaderGroupProps()} key={index}>
              {headerGroup.headers.map((column, index) => (
                <Th
                  {...column.getHeaderProps(
                    !(
                      column.Header === "Opções" ||
                      column.Header === "Ofício e/ou Decisão Jurídica"
                    ) && column.getSortByToggleProps({ title: undefined })
                  )}
                  w={column.Header === "Opções" ? "19%" : "27%"}
                  key={index}
                >
                  <Flex
                    flexDir="row"
                    alignContent="center"
                    justifyContent={
                      column.Header === "Opções" ||
                      column.Header === "Ofício e/ou Decisão Jurídica"
                        ? "center"
                        : "flex-start"
                    }
                  >
                    <Text as="p">{column.render("Header")}</Text>

                    {column.Header !== "Opções" &&
                    column.Header !== "Ofício e/ou Decisão Jurídica" ? (
                      <Flex pl={1} alignItems="center">
                        {column.isSorted ? (
                          column.isSortedDesc ? (
                            <Icon as={FaSortDown} boxSize="14px" />
                          ) : (
                            <Icon as={FaSortUp} boxSize="14px" />
                          )
                        ) : (
                          <Icon as={FaSort} boxSize="14px" />
                        )}
                      </Flex>
                    ) : (
                      ""
                    )}
                  </Flex>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody {...getTableBodyProps}>
          {page.map((row, i) => {
            prepareRow(row);
            return (
              <Tr {...row.getRowProps()} key={i}>
                {row.cells.map((cell, index) => {
                  return (
                    <Td
                      key={index}
                      {...cell.getCellProps()}
                      py="6px"
                      fontWeight={500}
                      fontSize="14px"
                      lineHeight="21.6px"
                      color="#797A80"
                    >
                      {cell.render("Cell")}
                    </Td>
                  );
                })}
              </Tr>
            );
          })}
        </Tbody>
        {isOpenVisualizarEditar && pessoaId !== -1 && (
          <VisualizarEditarPessoaModal
            isOpen={isOpenVisualizarEditar}
            onOpen={onOpenVisualizarEditar}
            onClose={handleCloseVisualizarEditarModal}
            id={pessoaId}
            isEdicao={isEdicao}
            editarPenaServ={editarPenaServ}
            setEditarPenaServ={setEditarPenaServ}
            roleKeycloack={roleKeycloack}
            user={user}
            idPJ={idPJ}
          />
        )}
        {isOpenDesligar && dataInicioAtividades && pessoaId !== -1 && (
          <DesligarModal
            isOpen={isOpenDesligar}
            onOpen={onOpenDesligar}
            onClose={onCloseDesligar}
            id={pessoaId}
            idSA={idSA}
            inicioAtividade={dataInicioAtividades}
            handlePessoaDesligada={handlePessoaDesligada}
          />
        )}
      </Table>
      <TablePagination
        nItens={nItens}
        selecionarTotalItens={selecionarTotalItens}
        irParaPagina={irParaPagina}
        pageSize={state.pageSize}
        setPageSize={setPageSize}
        rows={rows}
        gotoPage={gotoPage}
        canPreviousPage={canPreviousPage}
        previousPage={previousPage}
        pageOptions={pageOptions}
        pageIndex={state.pageIndex}
        canNextPage={canNextPage}
        nextPage={nextPage}
        pageCount={pageCount}
      />
    </Flex>
  );
};

export default TableEquipe;
